import React from "react";
import { Snackbar, Alert, AlertColor } from "@mui/material";

interface DtSnackbarProps {
  open: boolean;
  message: string;
  severity?: AlertColor;
  onClose: () => void;
  autoHideDuration?: number;
}

const DtSnackbar: React.FC<DtSnackbarProps> = ({
  open,
  message,
  severity = "info",
  onClose,
  autoHideDuration = 4000,
}) => (
  <Snackbar
    anchorOrigin={{ vertical: "top", horizontal: "center" }}
    open={open}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
  >
    <Alert
      onClose={onClose}
      severity={severity}
      sx={{ width: "100%", fontSize: "1.1rem"}}
    >
      {message}
    </Alert>
  </Snackbar>
);

export {DtSnackbar};